import React from 'react';
import { ContractorActivity } from '../../../types';
import { Formik } from 'formik';
import { Form, SubmitButton, Input, DatePicker, Select } from 'formik-antd';
import { Row, Col, Button } from 'antd';
import ContentWrapper from '../../../Components/ContentWrapper';
import { TimesheetStatus } from '../../../API';

const ContractorActivityForm = ({
  record,
  close,
}: {
  record: ContractorActivity | null;
  close: () => void;
}): React.ReactElement => {
  const isLocked = record?.timesheet?.submitted && record?.timesheet.status !== TimesheetStatus.REJECTED;
  return (
    <div data-testid="activity-form">
      <ContentWrapper>
        <Formik initialValues={record || ({} as ContractorActivity)} onSubmit={() => {}}>
          {(formProps: any): React.ReactElement => (
            <Form
              layout="vertical"
              // labelCol={{
              //   span: 6,
              // }}
              // wrapperCol={{
              //   span: 18,
              // }}
              // labelAlign="left"
            >
              <Row>
                <Col span={24}>
                  <Form.Item
                    name={`description`}
                    label="Task"
                    required
                    showValidateSuccess
                    showInitialErrorAfterTouched
                  >
                    <Input name="description" readOnly />
                  </Form.Item>
                  <Form.Item name={`assignedBy`} label="Assigned By">
                    <Input name="assignedBy" readOnly />
                  </Form.Item>
                  <Form.Item name={`team`} label="Team">
                    <Input name="team" readOnly />
                  </Form.Item>
                  <Form.Item name={`status`} label="Status">
                    <Input name="status" readOnly />
                  </Form.Item>
                  <Form.Item name={`startDate`} label="Start Date">
                    <Input name="startDate" readOnly />
                  </Form.Item>
                  <Form.Item name={`endDate`} label="Expected / Completion Date">
                    <Input name="endDate" readOnly />
                  </Form.Item>
                  <Form.Item name={`document`} label="Link to the document in the archiving folder">
                    <Input name="document" readOnly />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginTop: '20px' }}>
                <Col span={24}>
                  <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="default" onClick={close}>
                      Back
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ContentWrapper>
    </div>
  );
};

export default ContractorActivityForm;
